<template>
  <Content
    header-image-src="/img/content/usimsa-quality-guarantee-thumb.webp"
    :header-title="['해외 데이터의 모든 것', '독보적인, 유심사', '품질보장 알려드림']"
    date="2026.04.15"
  >
    <p class="typo-1 mt-8 mb-16">
      안녕하세요. 유심사 에디터예요. <br />
      오늘 다루어 볼 콘텐츠는 유심사 품질보장이에요 🫡
    </p>
    <p class="typo-1 mb-30">해외 데이터 품질에 대한 모든 것을 아티클로 담아봤어요.</p>

    <!-- 1. 품질보장, 왜 시작하게 됐을까? -->
    <section>
      <h2 class="title-typo-1 bg-yellow mb-16">1. 품질보장, 왜 시작하게 됐을까?</h2>
      <p class="title-typo-2 mb-default">해외에서 데이터가 안 된다는 건, 단순한 불편이 아니에요.</p>
      <p class="typo-1 mb-default">
        지도를 못 열고, 예약을 못 확인하고, 가이드에게 연락도 못 하는 망가진 여행 상황이에요.
      </p>
      <p class="typo-1 mb-default">
        유심사를 오래 사용해 주신 분들께서는 익숙하지 않은 경험이겠지만, 일부 고객분들로부터 이런
        피드백을 받았어요.
      </p>
      <blockquote class="info-box mb-default">
        <div class="info-icon">
          <span style="font-size: 16px">💡</span>
        </div>
        <p class="info-text">
          "타사보다 품질이 좋은지 잘 모르겠다" <br />
          "이번엔 예전만큼 잘 안 됐어요"
        </p>
      </blockquote>
      <p class="typo-1 mb-default">유심사는 이 피드백을 무겁게 받아들였어요.</p>
      <p class="typo-1 mb-30">그래서 품질에 대한 약속을 공식 정책으로 선언하기로 했어요.</p>
    </section>
    <Separator class="mb-30" />

    <!-- 2. 타사는 품질보장을 할까? -->
    <section>
      <h2 class="title-typo-1 bg-yellow mb-16">2. 타사는 품질보장을 할까?</h2>
      <p class="typo-1 mb-16">솔직하게 알려드릴게요.</p>
      <p class="typo-1 mb-16">
        현재 해외 eSIM · 유심 시장의 대부분은 <strong>판매 → 개통 → 끝</strong> 구조예요.
      </p>
      <table class="mb-16">
        <thead>
          <tr>
            <th style="width: 110px">구분</th>
            <th>타사구조</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>판매</td>
            <td>eSIM / 유심 판매</td>
          </tr>
          <tr>
            <td>개통</td>
            <td>매뉴얼 제공</td>
          </tr>
          <tr>
            <td>장애 발생</td>
            <td>고객 책임</td>
          </tr>
          <tr>
            <td>사후 보상</td>
            <td>없음</td>
          </tr>
        </tbody>
      </table>
      <p class="typo-1 mb-4">타사는 운영 비용과 부담 때문에 고객 경험 보호를 포기한 구조예요.</p>
      <p class="typo-1 mb-30">
        <strong>유심사는 여기서부터 다르게 가려고 해요.</strong>
      </p>
    </section>
    <Separator class="mb-30" />

    <!-- 3.오직, 유심사만 품질보장이에요 -->
    <section>
      <h2 class="title-typo-1 bg-yellow mb-16">3.오직, 유심사만 품질보장이에요</h2>
      <p class="typo-1 mb-16">
        한국에서도 일부 음영 지역에 있을 경우 통신이 잘 되지 않아 통신사 고객센터로 문의해 보신
        경험이 있으시죠?
      </p>
      <p class="typo-1 mb-4">
        <strong> 통신 장애는 ‘대체 수단 비용’을 강제 발생시켜요. </strong>
      </p>
      <p class="typo-1 mb-16">
        통신 장애는 단순한 불편이 아니라, 즉각적인 ‘추가 지출’을 만들어 내고 있어요.
      </p>
      <table class="mb-16">
        <thead>
          <tr>
            <th style="width: 110px">상황</th>
            <th>발생 비용</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>대체 유심 구매</td>
            <td>1~3만원</td>
          </tr>
          <tr>
            <td>포켓와이파이 렌탈</td>
            <td>~2만원/일</td>
          </tr>
          <tr>
            <td>택시 이동</td>
            <td>2~10만원</td>
          </tr>
          <tr>
            <td>액티비티 위약금</td>
            <td>5~20만원</td>
          </tr>
        </tbody>
      </table>
      <p class="typo-1 mb-30">평균적으로 통신 장애가 발생하면 3만~15만원의 추가 비용 발생해요.</p>
    </section>
    <Separator class="mb-30" />

    <!-- 4.왜 고객 불만이 반복되는가? -->
    <section>
      <h2 class="title-typo-1 bg-yellow mb-16">4.왜 고객 불만이 반복되는가?</h2>
      <aside class="info-box mb-16">
        <div class="info-icon">
          <span style="font-size: 16px">💡</span>
        </div>
        <p class="info-text"><b> 여기서부터 집중해야 돼요 👀 </b></p>
      </aside>
      <h3 class="typo-1 mb-4 sub-title-h3">
        <strong> 유심사 품질보장이란? </strong>
      </h3>
      <p class="typo-1 mb-16">
        이용 중 불편을 느끼셨다면, 사용량과 무관하게 환불을 보장해 드려요. <br />
        품질에 대한 약속이 먼저고, 환불은 그 약속을 지키는 안전장치예요.
      </p>
      <h3 class="typo-1 mb-4 sub-title-h3"><strong> 품질보장 이용 방법 </strong> <br /></h3>
      <p class="typo-1 mb-16">복잡하지 않아요. 딱 4단계예요.</p>

      <table class="mb-16">
        <thead>
          <tr>
            <th style="width: 110px">단계</th>
            <th>내용</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1단계</td>
            <td>유심사 고객센터로 환불 요청</td>
          </tr>
          <tr>
            <td>2단계</td>
            <td>담당자가 품질보장 사유 확인</td>
          </tr>
          <tr>
            <td>3단계</td>
            <td>자동환불 대기 상태로 전환</td>
          </tr>
          <tr>
            <td>4단계</td>
            <td>72시간 후 자동환불 완료</td>
          </tr>
        </tbody>
      </table>
      <h3 class="typo-1 mb-16 sub-title-h3">
        <strong> 꼭 확인해 주세요 </strong>
      </h3>
      <table class="mb-30">
        <thead>
          <tr>
            <th style="width: 110px">항목</th>
            <th>내용</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>신청 가능 기간</td>
            <td>구매확정일로부터 30일 이내</td>
          </tr>
          <tr>
            <td>적용 채널</td>
            <td>유심사 자사몰에 한함</td>
          </tr>
          <tr>
            <td>대상</td>
            <td>회원 / 비회원 전체</td>
          </tr>
          <tr>
            <td>USIM 반품 배송비</td>
            <td>면제</td>
          </tr>
          <tr>
            <td>제외 상품</td>
            <td>충전 / 연장 상품 (원주문 만족으로 간주)</td>
          </tr>
          <tr>
            <td>30일 초과 시</td>
            <td>고객센터 문의로 별도 처리</td>
          </tr>
        </tbody>
      </table>
    </section>
    <Separator class="mb-30" />

    <!-- 5.유심사가 품질을 만드는 방법 -->
    <section>
      <h2 class="title-typo-1 bg-yellow mb-16">5.유심사가 품질을 만드는 방법</h2>
      <div class="info-box mb-16">
        <div class="info-icon">
          <span style="font-size: 16px">💡</span>
        </div>
        <p class="info-text">
          <strong> 환불보다, 환불할 일이 없도록 처음부터 품질을 만드는 구조 </strong>를 갖추고
          있어요.<br />
          유심사의 품질보장은 단순히 "불만족 시 환불"을 제공하는 정책이 아니에요.
        </p>
      </div>
      <h3 class="w-full typo-1 mb-16 sub-title-container">
        <strong class="ml-4">1. 현장 직접 테스트 </strong>
      </h3>
      <nuxt-img
        :src="'/img/content/usimsa-quality-guarantee-contents-1.webp'"
        class="w-full mb-16"
      />
      <div class="sub-info-box">
        <p class="typo-1">
          발리, 방콕, 도쿄 등 판매 국가를 직접 방문해 공항·호텔·관광지에서 실측해요. 단순 벤치마크가
          아닌, 여행자 실사용 환경 그대로예요.
        </p>
      </div>

      <h3 class="typo-1 mb-16 sub-title-container">
        <strong class="ml-4">2. 데이터 기반 상품 고도화 </strong>
      </h3>
      <nuxt-img
        :src="'/img/content/usimsa-quality-guarantee-contents-2.webp'"
        class="w-full mb-16"
      />
      <div class="sub-info-box">
        <p class="typo-1">
          고객 리뷰, CS 접수 사유, 품질보장 환불 데이터를 국가 / 통신사 / 상품 단위로 분류해
          분석해요.
          <br />
          기준 미달 상품은 즉시 판매를 중단해요.
        </p>
      </div>

      <h3 class="typo-1 mb-16 sub-title-container">
        <strong class="ml-4">3. 통신사 파트너 품질 관리 </strong>
      </h3>
      <nuxt-img
        :src="'/img/content/usimsa-quality-guarantee-contents-3.webp'"
        class="w-full mb-16"
      />
      <div class="sub-info-box">
        <p class="typo-1">
          전 세계 파트너사와 품질 기준 계약을 맺어요. <br />
          이상 징후 발생 시 즉시 피드백을 전달하고, 기준을 지속 충족하지 못하는 파트너는 교체해요.
        </p>
      </div>

      <h3 class="typo-1 mb-16 sub-title-container">
        <strong class="ml-4">4. 품질보장 → 개선 루프 </strong>
      </h3>
      <nuxt-img
        :src="'/img/content/usimsa-quality-guarantee-contents-4.webp'"
        class="w-full mb-16"
      />
      <div class="sub-info-box">
        <p class="typo-1 mb-16">
          접수된 품질보장 건은 월별 리뷰를 거쳐 상품팀·파트너팀 개선 액션으로 연결돼요. <br />
          다음 고객은 반드시 더 나은 품질을 경험해요.
        </p>
      </div>
      <Separator class="mb-16" />

      <h3 class="mb-4 typo-1 mb4"><strong>품질보장 데이터 방식</strong></h3>
      <p class="typo-1 mb-8">품질보장 데이터가 흐르는 방식을 보면 더 잘 이해가 돼요.</p>
      <div class="ol-wrap">
        <ol class="row row-3">
          <li class="ol-step">
            <div class="ol-step-box-wrap">
              <div class="icon">✅</div>
              <p class="ol-step-text">품질보장 접수</p>
            </div>
            <nuxt-img
              class="mx-5"
              src="/img/basic-icon/arrow-right.svg"
              height="70"
              width="20"
              alt="back"
            />
          </li>

          <li class="ol-step">
            <div class="ol-step-box-wrap">
              <div class="icon">🌍</div>
              <p class="ol-step-text">국가 · 망 상품분류</p>
            </div>
            <nuxt-img
              class="mx-5"
              src="/img/basic-icon/arrow-right.svg"
              height="70"
              width="20"
              alt="back"
            />
          </li>

          <li class="ol-step">
            <div class="ol-step-box-wrap">
              <div class="icon">📊</div>
              <p class="ol-step-text">월별 품질 리뷰</p>
            </div>
            <nuxt-img
              class="mx-5"
              src="/img/basic-icon/arrow-right.svg"
              height="70"
              width="20"
              alt="back"
            />
          </li>
        </ol>

        <ol class="row row-2">
          <li class="row-2-ol-step">
            <div class="ol-step-box-wrap">
              <div class="icon">⚡</div>
              <p class="ol-step-text">팀 공유 & 개선 액션</p>
            </div>
            <nuxt-img
              class="mx-5"
              src="/img/basic-icon/arrow-right.svg"
              height="70"
              width="20"
              alt="back"
            />
          </li>

          <li class="row-2-ol-step">
            <div class="ol-step-icon-wrap">
              <div class="icon">✈️</div>
              <p class="ol-step-text">
                더 나은 <br />
                품질 제공
              </p>
            </div>
          </li>
        </ol>
      </div>
    </section>
    <Separator class="mb-30" />

    <!-- 유심사가 품질 보장을 하는 이유 -->
    <section>
      <h2 class="title-typo-1 bg-yellow mb-16">유심사가 품질보장을 하는 이유</h2>
      <div class="empty-space" />
      <h3 class="typo-caption mb-8 sub-title-container">
        <strong class="ml-4">Q. 왜 데이터 사용량과 무관하게 품질보장을 하나요? </strong>
      </h3>
      <p class="typo-caption">
        A. 품질 문제는 고객의 책임이 아니고 서비스 운영/현지 통신 네트워크 등 문제가 복합적으로 있기
        때문이에요
      </p>
      <div class="min-empty-space" />

      <h3 class="typo-caption mb-8 sub-title-container">
        <strong class="ml-4">Q. 품질보장을 통해 유저가 얻는 것은 무엇이 있나요?</strong>
      </h3>
      <p class="typo-caption">
        A. 환불하지 않는 경험을 만들고자 여행자의 현지 경험을 축적하여 여행 때 더욱 개선된 서비스를
        경험해 볼 수 있어요
      </p>
      <div class="min-empty-space" />

      <h3 class="typo-caption mb-8 sub-title-container">
        <strong class="ml-4">Q. 타사도 비슷한 정책이 있나요?</strong>
      </h3>
      <p class="typo-caption">A. 오직, 유심사 에만 있는 정책이에요.</p>
      <div class="min-empty-space" />

      <h3 class="typo-caption mb-8 sub-title-container">
        <strong class="ml-4">Q. 앞으로도 계속 이 정책을 유지하나요?</strong>
      </h3>
      <p class="typo-caption">
        A. 품질보장은 앞으로의 유심사를 만들어 나가는데 기반이 되고 이를 기반으로 유지 또는 축소보다
        더 기대 이상의 정책을 수립하고 서비스를 할 예정이에요.
      </p>
      <div class="min-empty-space" />

      <p class="typo-1 mb-16">
        여행자의 데이터 경험 그리고 여행 전체를 책임지는 브랜드가 되고 싶어요.
      </p>
      <p class="typo-1 mb-30">
        품질보장은 그 첫 번째 공식 선언이에요. <br />👨‍🎤 앞으로도 품질보장을 통해 축적된 데이터를
        바탕으로 국가별, 망별 품질을 계속 개선해 나갈게요. 🚀
      </p>
    </section>
  </Content>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'center'
})
useHead({
  title: '해외 데이터의 모든 것 독보적인, 유심사 품질보장 알려드림',
  meta: [
    {
      hid: 'description',
      name: 'description'
    }
  ]
})
</script>
<style scoped lang="scss">
.sub-title-container {
  background-color: $usdg-color-brand-050;
}
.icon {
  background-color: $usdg-color-gray-050;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 70px;
  border-radius: 50%;
}
.ol-wrap {
  border: 1px solid #eeeeee;
  border-radius: 16px;
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  gap: clamp(15px, 3vw, 30px);
  align-items: center;
  margin-bottom: 30px;
}

ol li {
  list-style: none;
  justify-content: space-around;
}

.row-3 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-content: space-around;
  padding-left: 0;
  gap: 5px;
}

.row-2 {
  display: flex;
  justify-content: center;
  padding: 0;
  gap: clamp(5px, 3vw, 48px);
}

.row-3,
.row-2 {
  width: 100%;
  box-sizing: border-box;
}

.ol-step-box-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
.ol-step-text {
  width: 70px;
  text-align: center;
  font-style: normal;
  font-weight: 700;
}

.ol-step {
  width: 100%;
  display: flex;
  gap: 5px;
}

.row-2-ol-step {
  max-width: 150px;
  min-width: 70px;
  display: flex;
  gap: clamp(5px, 3vw, 48px);
}

.sub-title-h3 {
  height: 56px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
}

.sub-info-box {
  min-height: 112px;
  margin-bottom: 16px;
}

.empty-space {
  width: 100%;
  height: 28px;
  margin-bottom: 8px;
}

.min-empty-space {
  width: 100%;
  height: 24px;
  margin-bottom: 16px;
}

.typo-caption {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  padding: 0 4px 0 10px;
}
</style>
